<div id="graphdocumentsdiv" #graphdocumentsdiv class="graph-documents" [style.height.px]="height"></div>